import { globalFunctions } from '@/utils/globalFunctions'

export default {
    install(app) {
        app.provide('globalFunctions', globalFunctions)
    }
}